const cache = `v=${Date.now()}`;

const loadExistingElement = (el, resolve, reject) => {
    if (el.getAttribute('data-loaded') == 'true') {
        resolve();
    }
    else if (el.getAttribute('data-error') == 'true') {
        reject();
    }
    else {
        // Element not loaded yet, wait for it
        el.addEventListener('load', () => {
            resolve();
        }, {once: true});
        el.addEventListener('error', () => {
            reject();
        }, {once: true});
    }
};

const loadJavaScript = (src) => new Promise((resolve, reject) => {
    const el = document.getElementById(src);
    if (el) {
        loadExistingElement(el, resolve, reject);
        return;
    }
    const script = document.createElement('script');
    script.setAttribute('id', src);
    script.src = `${src}${src.includes('?') ? '&' : '?'}${cache}`;
    script.onload = () => {
        script.setAttribute('data-loaded', true);
        resolve();
    };
    script.onerror = () => {
        script.setAttribute('data-error', true);
        reject();
    }
    document.head.appendChild(script);
});

const loadCSS = (href) => new Promise((resolve, reject) => {
    const el = document.getElementById(href);
    if (el) {
        loadExistingElement(el, resolve, reject);
        return;
    }
    const stylesheet = document.createElement('link');
    stylesheet.setAttribute('id', href);
    stylesheet.href = `${href}${href.includes('?') ? '&' : '?'}${cache}`;
    stylesheet.setAttribute('rel', 'stylesheet');
    stylesheet.onload = () => {
        stylesheet.setAttribute('data-loaded', true);
        resolve();
    };
    stylesheet.onerror = () => {
        stylesheet.setAttribute('data-error', true);
        reject();
    }
    document.head.appendChild(stylesheet);
});

export {
    loadJavaScript,
    loadCSS,
};